import { css, CSSResult } from 'lit'

export const style: CSSResult = css`
.divider {
  margin: 30px 0;
  background: var(--cs-color-border-light);
  width: 100%;
  height: 1px;
}

.swatch-group { 
  display: flex;
  flex-wrap: wrap;
  gap: 20px 30px;
}

.swatch-group-name {
  text-transform: capitalize;
  color: var(--cs-color-text-muted);
  display: block;
  margin-bottom: 10px;
}

.swatch {
  border: 1px solid var(--cs-color-border-light);
  border-radius: 8px;
  height: 60px;
  width: 225px;
  display: flex;
  justify-content: end;
  align-items: end;
  text-align: right;
  padding: 8px;
  font-size: 12px;
  font-family: monospace;
}

.swatch-title {
  text-transform: capitalize;
  display: block;
  margin: 5px 0;
}
`
